module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "menuAlign": "end"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n    " + _vm._s(_vm.username) + "\n    "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v("退出平台")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1ee604f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 502
// module chunks = 1